const config = {
  isInDev: true,
  endpoints: {
    devContactEmail: 'https://www.hgscores.com/api/beta_email.php',
    practiceGroupsEndpoint: 'https://api.hgscores.com/practice-groups/',
  },
};
export default config;
